import { CUMULATIVE_DIVIDENDS_ALIAS } from 'common/constants/cap-table';
import { EvaluatedCell } from 'models/interfaces/spreadsheet-types/core-types';
import { MULTIPLE_OF_ALIAS, PRICE_PLUS_DIVIDENDS_VALUE } from './constants';
import { LiquidationPreferenceLedgerChange } from './liqPrefLedgerAfterCellChanged.props';

const afterCellChanged = (changes: LiquidationPreferenceLedgerChange[], cells: { [key: string]: EvaluatedCell }) => {
  const changeList = [] as LiquidationPreferenceLedgerChange[];

  changes.forEach(change => {
    const { cell, value } = change;
    changeList.push({ cell, value });
    if (cell.alias === MULTIPLE_OF_ALIAS && Number(value) === PRICE_PLUS_DIVIDENDS_VALUE) {
      // find has_dividends cell in the same column
      const targetHasDividendsCell = Object.values(cells).find(
        ({ alias, y }) => alias === CUMULATIVE_DIVIDENDS_ALIAS && y === cell.y
      );
      changeList.push({ cell: targetHasDividendsCell!, value: 1 });
    }
  });
  return changeList;
};

export default afterCellChanged;
